import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HeroSection.css";

const sliderImages = [
  "https://res.cloudinary.com/dhbjxspxa/image/upload/v1774764235/Gemini_Generated_Image_1sjh7o1sjh7o1sjh_kyo2pl.png",
  "https://res.cloudinary.com/dhbjxspxa/image/upload/v1774764263/IMG_0228_dwvcc8.png",
  "https://res.cloudinary.com/dhbjxspxa/image/upload/v1774682972/products/ky8le6t1wkb1jsfjrc9e.jpg",
  "https://res.cloudinary.com/dhbjxspxa/image/upload/v1774764217/61-6zV33-cL.jpg_lgwnc1.webp"

];

const HeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  /* ================= PRELOAD IMAGES ================= */
  useEffect(() => {
    sliderImages.forEach((src) => {
      const img = new window.Image();
      img.src = src;
    });
  }, []);

  /* ================= AUTO SLIDER ================= */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % sliderImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  /* ================= NAVIGATION FUNCTION ================= */
  const goToCategory = (categoryId) => {
    navigate(`/shop?category=${categoryId}`);
  };

  const largeCardStyle = {
    // ⭐️ Removed the inline dark gradient so CSS can handle it cleanly
    backgroundImage: `url("${sliderImages[currentIndex]}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    transition: "background-image 0.9s ease-in-out",
  };

  return (
    <section className="hero-section section-reveal">
      {/* ================= LEFT MAIN SLIDER ================= */}
      <div className="hero-card large" style={largeCardStyle}>
        <h2>Explore out Battery Packs and Integrated Inverters!</h2>
        <p>Our flagship product for reliable, off-grid power.</p>

        <button onClick={() => goToCategory("smart-integrated-inverters")}>
          Shop Now
        </button>
      </div>

      {/* ================= RIGHT CATEGORY CARDS ================= */}
      <div className="hero-card-grid">
        {/* Smart Lithium Ion */}
        <div
          className="hero-card small"
          onClick={() => goToCategory("smart-li-ion-batteries")}
          style={{
            backgroundImage: `url(https://res.cloudinary.com/dhbjxspxa/image/upload/v1777486108/products/fdmsc6vgxzxzinifuauh.jpg)`,
          }}
        >
          <h3>Lithium-Ion Battery Packs</h3>
          <p>High energy density solutions</p>
        </div>

        {/* Smart Lithium Phosphate */}
        <div
          className="hero-card small"
          onClick={() => goToCategory("smart-lithium-phosphate-battery")}
          style={{
            backgroundImage: `url(https://res.cloudinary.com/dhbjxspxa/image/upload/v1777477346/products/pnpdnvvsclfihzq7rpdu.jpg)`,
          }}
        >
          <h3>Lithium Iron Phosphate Packs</h3>
          <p>Safe & long life performance</p>
        </div>

        {/* EV Batteries */}
        <div
          className="hero-card small"
          onClick={() => goToCategory("electric-cycle-batteries")}
          style={{
            backgroundImage: `url(https://res.cloudinary.com/dhbjxspxa/image/upload/v1777475970/products/iqwaduamxpvaolfgokap.jpg)`,
          }}
        >
          <h3>EV Batteries</h3>
          <p>Powering electric mobility</p>
        </div>

        {/* Bike Batteries */}
        <div
          className="hero-card small"
          onClick={() => goToCategory("smart-lithium-phosphate-battery")}
          style={{
            backgroundImage: `url(https://res.cloudinary.com/dhbjxspxa/image/upload/v1777576228/products/fazkce0sjt6vh3lfynps.jpg)`,
          }}
        >
          <h3>Inverter Batteries</h3>
          <p>Compact & powerful solutions</p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
